import { render, staticRenderFns } from "./AccontsReceList.vue?vue&type=template&id=73351bc4&scoped=true&"
import script from "./AccontsReceList.vue?vue&type=script&lang=js&"
export * from "./AccontsReceList.vue?vue&type=script&lang=js&"
import style0 from "./AccontsReceList.vue?vue&type=style&index=0&id=73351bc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73351bc4",
  null
  
)

export default component.exports